// Invalidates the server session and returns the UAE Pass single-logout URL
// (when the session was a UAE Pass login). The caller (useLogout) clears the
// local session and redirects to that URL to end the UAE Pass IdP session.
import { useMutation } from '@tanstack/vue-query'
import { logout } from '../authEndpoints'
import { parseLogout } from '../authParser'

export function useLogoutMutation() {
  return useMutation({
    mutationFn: (payload: { refreshToken: string }) => logout(payload).then(parseLogout),
  })
}
